import CustomLoadingButton from 'Components/CustomLoadingButton'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined'
import type { ButtonProps } from '@mui/material/Button'
import { t } from 'ttag'

interface SPMActivityDialogButtonProps extends ButtonProps {
  activityEndDate: string | undefined
  isActive: boolean
  isLoading: boolean
}

export default function SPMActivityDialogButton({
  activityEndDate,
  isActive,
  isLoading,
  ...restProps
}: Readonly<SPMActivityDialogButtonProps>) {
  let buttonText = t`Activate`
  let buttonIcon = <PlayCircleOutlineIcon />
  let buttonColor: 'success' | 'error' = 'success'
  if (isActive) {
    buttonText = activityEndDate ? t`Cancel cease` : t`Cease`
    buttonIcon = <StopCircleOutlinedIcon />
    buttonColor = 'error'
  }

  return (
    <CustomLoadingButton
      isLoading={isLoading}
      size="small"
      type="submit"
      color={buttonColor}
      icon={buttonIcon}
      iconPosition="start"
      {...restProps}
    >
      {buttonText}
    </CustomLoadingButton>
  )
}
